var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTennisBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.42167 14.2067C3.90703 15.6906 5.89993 16.5561 7.99833 16.6283C7.6125 14.3175 8.3025 11.8608 10.0817 10.0817C11.8617 8.3025 14.3175 7.6125 16.6283 7.99833C16.5517 5.97083 15.7508 3.96583 14.2067 2.42167C12.6625 0.8775 10.6567 0.0766667 8.63 0C9.01583 2.31083 8.32583 4.7675 6.54667 6.54667C4.76667 8.32583 2.31083 9.01583 0 8.63C0.0715224 10.7286 0.937054 12.7217 2.42167 14.2067Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.26 11.26C10.5818 11.9388 10.0816 12.7744 9.80383 13.6929C9.52603 14.6113 9.47921 15.5841 9.66754 16.525C11.3867 16.2489 12.975 15.4375 14.2063 14.2062C15.4375 12.975 16.2489 11.3867 16.525 9.6675C15.5842 9.4794 14.6114 9.52632 13.693 9.80411C12.7746 10.0819 11.9389 10.582 11.26 11.26ZM5.36837 5.36833C6.04659 4.68956 6.54678 3.85389 6.82458 2.93545C7.10238 2.01701 7.1492 1.0442 6.96087 0.103333C5.24151 0.37927 3.65304 1.19063 2.42164 2.42188C1.19024 3.65313 0.378685 5.24151 0.102539 6.96083C1.04354 7.149 2.01643 7.10212 2.93498 6.82433C3.85352 6.54654 4.68935 6.04643 5.36837 5.36833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennisBall);
export default __webpack_public_path__ + "static/media/Tennis_Ball.3bc9ef1b2d9e08af0e011ddc4230a390.svg";
export { ForwardRef as ReactComponent };